import { Link } from "react-router-dom";

import styled from "@emotion/styled";

export const LinkStyled = styled(Link)`
  color: inherit;
  text-decoration: none;
  display: inline-flex;
  vertical-align: middle;

  /* padding: 7px 7px;
  border-radius: 12px;
  transition:
  outline-color 0.3s ease,
  color 0.3s ease;
  outline: 2px solid transparent;
  &:focus {
    outline-color: #d4fe75;
 } */
`;

export const Span = styled.span`
  font-size: 32px;
  font-weight: 700;
  line-height: 1.05;
`;
